import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';
import { useContextSelector } from 'use-context-selector';

const { getTabAggregates, getPublicAggregates } = opportunitiesServices();
export const useTabAggregates = () => {
  const filters = useContextSelector(OpportunitiesContext, (state) => state.filters);
  const { data, isLoading: tabIsLoading } = getTabAggregates(filters);
  const { data: publicAggregates, isLoading: publicLoading } = getPublicAggregates(filters);
  const {
    new: newCount = 0,
    submitted: submittedCount = 0,
    not_interested: notInterestedCount = 0,
    total_filtered_project_count = 0,
  } = data?.data || { new: 0, submitted: 0, not_interested: 0, total_filtered_project_count: 0 };

  const tabs = [
    { name: 'new', header: 'New', disabled: false, count: newCount },
    { name: 'submitted', header: 'Applied', disabled: false, count: submittedCount },
    { name: 'not_interested', header: 'Not Interested', disabled: false, count: notInterestedCount },
  ];

  return {
    publicLoading,
    publicAggregates,
    tabs,
    tabIsLoading,
    total_filtered_project_count,
  };
};
